const subsidiariesRoute = {
	name: 'subsidiaries',
	path: 'subsidiaries',
	// redirect: 'subsidiaries/list',
	meta: {
		title: 'Agencias',
	},
	component: () => import('@/pages/configuration/subsidiaries'),
};

export default subsidiariesRoute;



// WEBPACK FOOTER //
// ./src/router/configuration/subsidiaries/index.js